import { OrderHistoryWithdrawalSection } from '@/views/withdrawal/components/OrderHistoryWithdrawalSection';

import { GiftingSection } from './sections/GiftingSection';
import { OrderAddressesSection } from './sections/OrderAddressesSection';
import { OrderDetailsHeaderSection } from './sections/OrderDetailsHeaderSection';
import { OrderLinesSection } from './sections/OrderLinesSection';
import { OrderMetaSection } from './sections/OrderMetaSection';
import { OrderReminderSection } from './sections/OrderReminderSection';
import { OrderStatusStepperSection } from './sections/OrderStatusStepperSection';
import { OrderTransactionSummarySection } from './sections/OrderTransactionSummarySection';

export function OrderDetailsSections() {
  return (
    <>
      <OrderDetailsHeaderSection />
      <OrderReminderSection />
      <OrderMetaSection />
      <OrderStatusStepperSection />
      <OrderLinesSection />
      <OrderTransactionSummarySection />
      <OrderAddressesSection />
      <GiftingSection />
      <OrderHistoryWithdrawalSection />
    </>
  );
}
